import React from 'react'
import PropTypes from 'prop-types'
import {get, drop} from 'lodash'
import className from 'classnames'
import Head from 'next/head'
import Link from 'next/link'
import dynamic from 'next/dynamic'

import {t, axios} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))

const Cases = ({cases = []}) => {
  return (
    <React.Fragment>
      <Meta title={`${t('pages.cases.title')} – ${t('layout.title')}`} />

      <div className='Cases'>
        <DualSlide>
          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.cases.dualslide.0.h2'),
                }}
              />

              <p className='DualSlide__p'>{t('pages.cases.dualslide.0.p')}</p>
            </div>

            <div className='DualSlide__wrapper__bar'></div>
          </div>

          <div className='DualSlide__image'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--4.jpg'
            />
          </div>
        </DualSlide>

        <div className='BodySpace'>
          {get(cases, '0') && (
            <React.Fragment>
              {(() => {
                const c = get(cases, '0')

                const L = ({children}) => {
                  return (
                    <Link href='/cases/[id]' as={`/cases/${get(c, 'slug')}`}>
                      {children}
                    </Link>
                  )
                }

                return (
                  <div className='Cases__hero'>
                    <div className='container'>
                      <img
                        className='Cases__hero__img'
                        alt='Cases__hero__img'
                        src={get(c, 'image_1.url')}
                      />

                      <div className='Cases__hero__wrapper'>
                        <h2 className='Cases__hero__h2'>
                          <L>
                            <a>{get(c, 'title')}</a>
                          </L>
                        </h2>

                        <div
                          className='Cases__hero__p'
                          dangerouslySetInnerHTML={{__html: get(c, 'summary')}}
                        ></div>

                        <div className='Cases__hero__buttons'>
                          <L>
                            <a className='Button'>{t('pages.cases.hero.a')}</a>
                          </L>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })()}
            </React.Fragment>
          )}

          <dl className='Cases__dl'>
            <div className='container'>
              {drop(cases).map((x, i) => (
                <Link
                  href='/cases/[id]'
                  as={`/cases/${get(x, 'slug')}`}
                  key={i}
                >
                  <a className='Cases__dl__item' key={i}>
                    <div className='Cases__dl__item__top'>
                      <img
                        className='Cases__dl__item__img'
                        alt='Cases__dl__item__img'
                        src={get(x, 'image_1.url')}
                      />

                      <div className='Cases__dl__item__wrapper'>
                        <dt className='Cases__dl__item__dt'>
                          <h3>{get(x, 'title')}</h3>
                        </dt>

                        <dd
                          className='Cases__dl__item__dd'
                          dangerouslySetInnerHTML={{__html: get(x, 'summary')}}
                        />
                      </div>
                    </div>

                    <div className='Buttons'>
                      <span className='Cases__dl__item__a'>
                        {t('pages.cases.dl.a')}
                      </span>
                    </div>
                  </a>
                </Link>
              ))}
            </div>
          </dl>
        </div>
      </div>
    </React.Fragment>
  )
}

Cases.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let cases

  try {
    cases = await axios.get('/case_studies')
  } catch (e) {}

  return {
    props: {
      cases: get(cases, 'data.data'),
    },
  }
}

export default Cases
